// extracted by mini-css-extract-plugin
export default {"rightcol-buttons":"ActionButtons_rightcol-buttons__DYyYP"};